/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Highlight_Team_ComplianceInputs */



/**
* | output |
* | --- |
* | "Compliance Copilot (EU AI Act)" |
*
* @param {Plan_Gate_Highlight_Team_ComplianceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_highlight_team_compliance = /** @type {((inputs?: Plan_Gate_Highlight_Team_ComplianceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Highlight_Team_ComplianceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot (EU AI Act)")
	return /** @type {LocalizedString} */ ("Compliance Copilot (EU AI Act)")
});